export const CONDITIONS_GENERALES_VENTES = `
1. OBJET
Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre le propriétaire du site et toute personne physique (ci-après "l'Utilisateur") souscrivant à un abonnement payant sur le site https://mon-budget-app.com.

2. SERVICES PROPOSÉS
"Mon Budget App" propose trois niveaux de services :

    Plan TRIAL : Gratuit pendant 90 jours (limité à 2 comptes).

    Plan STANDARD : Payant, permettant la gestion de 5 comptes et l'export des données.

    Plan PREMIUM : Payant, offrant un nombre illimité de comptes et des fonctionnalités collaboratives avancées.
    L'accès aux services payants nécessite la création d'un compte et le paiement préalable de l'abonnement.

3. TARIFS ET PAIEMENT
Les tarifs sont indiqués en Euros (€) et sont nets de taxe (TVA non applicable, art. 293 B du CGI). Le propriétaire du site se réserve le droit de modifier ses prix à tout moment, mais le service sera facturé sur la base du tarif en vigueur au moment de la validation de la souscription.
Le paiement s'effectue par carte bancaire ou prélèvement SEPA via la plateforme sécurisée Stripe.

4. DURÉE ET RÉSILIATION
Les abonnements STANDARD et PREMIUM sont conclus pour une durée d'un mois, renouvelables tacitement.
L'Utilisateur peut résilier son abonnement à tout moment depuis son espace "Paramètres" ou "Billing". La résiliation prendra effet à la fin de la période mensuelle en cours. Aucun remboursement n'est effectué pour la période entamée.

5. DROIT DE RÉTRACTATION
Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne peut être exercé pour les services de fourniture de contenus numériques non fournis sur un support matériel dont l'exécution a commencé après accord préalable exprès du consommateur et renoncement exprès à son droit de rétractation.
En validant votre abonnement, vous accédez immédiatement aux services et renoncez ainsi à votre droit de rétractation de 14 jours.

6. RESPONSABILITÉ ET GARANTIE
Le propriétaire du site s'efforce d'assurer une disponibilité du service 24h/24. Toutefois, la responsabilité de l'éditeur ne peut être engagée en cas de maintenance technique, d'interruption du réseau internet ou de bugs logiciels.
L'Utilisateur est seul responsable de l'exactitude des données financières qu'il saisit manuellement dans l'application.

7. MODIFICATION DES CGV
Le propriétaire du site se réserve le droit de modifier les présentes CGV à tout moment. Les nouvelles CGV seront notifiées à l'Utilisateur par e-mail ou via une notification sur le site 30 jours avant leur entrée en vigueur.

8. LITIGES
Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable sera recherchée avant toute action judiciaire devant les tribunaux compétents de Béziers.
`;